export default __webpack_public_path__ + "static/media/priority-low-glyph-16-px.193ab6fe.svg";